import React from "react";
import './styles.css';
import classNames from 'classnames';

export const vendedoresBodyTemplate = (rowData) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Vendedor</span>
            <span
                className={classNames(
                    'customer-badge',
                    'Vendedor-' + rowData['Vendedore.Nome']
                )}
            >
                {rowData['Vendedore.Nome']}
            </span>
        </React.Fragment>
    );
};

export const vendedoresItemTemplate = (option) => {
    return (
        <div className="p-multiselect-representative-option">
            <span
                className={classNames(
                    'customer-badge',
                    'Vendedor-' + option
                )}
            >
                {option}
            </span>
        </div>
    );
};